import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import { Toolbar, ToolbarGroup, ToolbarTitle } from 'material-ui/Toolbar';
import ReactGA from 'react-ga';

import SlackChannels from '../../containers/slack_channels';
import COLORS from '../../theme/colors';
import RemoveSlackDialog from './remove_slack_dialog/remove_slack_dialog';

import GA from '../../services/ga_events';

import './slack_source_manager.scss';

export default class SlackSourceManager extends Component {
  static propTypes = {
    team: PropTypes.object,
    loadSlackUserData: PropTypes.func.isRequired,
  };

  static defaultProps = {
    team: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      removeDialogOpen: false,
    };
  }

  componentWillMount() {
    this.props.loadSlackUserData();
  }

  openRemoveDialog() {
    this.setState({
      removeDialogOpen: true,
    });
  }

  closeRemoveDialog() {
    this.setState({
      removeDialogOpen: false,
    });
  }

  removeSlack() {
    window.open(this.props.team.appUrl, '_blank');
    this.closeRemoveDialog();
  }

  addToSlack() {
    window.location.href = '/api/slack/add';
  }

  render() {
    return (
      <div className="slack-source-manager">
        <Toolbar style={{ backgroundColor: COLORS.purple }}>
          <ToolbarGroup
            className="source-info"
            firstChild
          >
            <div className="slack-logo" />
            <ToolbarTitle text="Slack" style={{ color: '#ffffff' }} />
          </ToolbarGroup>
          <ToolbarGroup lastChild>
            {
              this.props.team
              ? <FlatButton
                label="Remove"
                style={{ color: COLORS.white }}
                onClick={() => { this.openRemoveDialog(this.props.team); }}
              />
              : <RaisedButton
                label="Add Slack"
                primary
                onClick={() => {
                  ReactGA.event(GA.addSlack);
                  this.addToSlack();
                }}
              />
            }
          </ToolbarGroup>
        </Toolbar>
        <div className="slack-content">
          <div className="info">
            {
              this.props.team
              ? this.props.team.teamName
              : 'Connect your Slack to your TeamHub. Click “Add Slack” to get started.'
            }
          </div>
          {
            this.props.team && <SlackChannels />
          }
        </div>

        {
          this.props.team &&
          <RemoveSlackDialog
            open={this.state.removeDialogOpen}
            removeTeam={() => { this.removeSlack(); }}
            teamName={this.props.team.teamName}
            onRequestClose={() => { this.closeRemoveDialog(); }}
          />
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/slack_source_manager/slack_source_manager.jsx